"use client";
import { BASE_IMAGE_URL } from "@/configs/globals";
import Image from "next/image";
import Link from "next/link";
import { AppearanceJsonType } from "@/types/appearcne";
import dynamic from "next/dynamic";

const TimerContent = dynamic(() => import("./Timer"), {
  ssr: false,
});

const Campain = ({
  appearanceJson,
}: {
  appearanceJson: AppearanceJsonType;
}) => {
  const start = appearanceJson?.campain?.dateRange?.[0];
  const end = appearanceJson?.campain?.dateRange?.[1];
  return (
    <>
      {(appearanceJson?.campain?.dateRange?.[0] ?? 0) < Date.now() &&
        (appearanceJson?.campain?.dateRange?.[1] ?? 0) > Date.now() && (
          <div className="relative h-[60px] w-full bg-white cursor-pointer">
            <Link
              aria-label="تصویر کمپین"
              href={appearanceJson?.campain?.link ?? ""}
            >
              <Image
                alt="تصویر کمپین"
                title="مشاهده جزئیات کمپین ویژه" //in this line we need title text for campain
                height={60}
                width={1900}
                src={BASE_IMAGE_URL! + appearanceJson?.campain?.imageUrl}
                className="h-[60px] object-cover place-self-center"
              />
            </Link>

            {appearanceJson.campain?.hasTimer && (
              <TimerContent start={start!} end={end!} />
            )}
          </div>
        )}
    </>
  );
};

export default Campain;
